export default __webpack_public_path__ + "static/media/no-classmates.9cba9488.png";